import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IRecommendationTypeModel extends IModel {
  recommendationTypeId: number;
  name: string;
  isActive: boolean;
}

export class RecommendationTypeModel
  extends Model
  implements ModelRecord<IRecommendationTypeModel>
{
  recommendationTypeId: number;
  name: string;
  isActive: boolean;

  constructor(params?: Partial<IRecommendationTypeModel>) {
    super(params);
    this.recommendationTypeId = defaultTo(params?.recommendationTypeId, 0);
    this.name = defaultTo(params?.name, '');
    this.isActive = defaultTo(params?.isActive, true);
  }
}
